export default function AppSection() {
  return (
    <section id="app" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20mobile%20phone%20in%20hand%20with%20glowing%20screen%20dark%20cozy%20environment%20orange%20and%20red%20warm%20tones%20night%20scene%20with%20soft%20bokeh%20lights&width=1920&height=800&seq=app-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-background-950/75"></div>

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-3">
          随时随地吃瓜
        </h2>
        <p className="text-white/60 text-sm md:text-base mb-8 max-w-md mx-auto">
          关注91吃瓜在线，不错过任何一个明星塌房和网红翻车
        </p>
        <a
          href="#"
          className="inline-flex items-center gap-3 px-8 py-3.5 bg-accent-500 text-background-50 font-medium text-sm rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
        >
          <span className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
            <i className="ri-smartphone-line text-sm"></i>
          </span>
          立即访问
        </a>
      </div>
    </section>
  );
}